import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { addMonths } from 'date-fns';
import { AnalyzeNettleie } from 'src/app/services/analyse/analyse.types';

@Component({
  selector: 'app-summary-nettleie',
  standalone: true,
  styleUrls: ['./summary.component.scss'],
  imports: [CommonModule, IonicModule],
  template: `
    <ion-row class="box-white">
      <ion-col>
        <p class="text-lg mb-0">
          <strong>Hvordan ble din {{ month }}? 🤔</strong>
        </p>
        <p>
          Du havnet på nettleietrinn
          <strong>
            {{ analyzedConsumption.current_step.limit }}-{{
              analyzedConsumption.current_step.next_limit
            }}
            kWh</strong
          >. Dette tilsvarer en kostnad på
          <strong> {{ analyzedConsumption.current_step.cost }} kr</strong>.
        </p>
        <p>
          {{ information }}
        </p>
      </ion-col>
    </ion-row>
  `
})
export class SummaryNettleieComponent {
  @Input() analyzedConsumption: AnalyzeNettleie;

  month: string;
  information: string;

  ngOnChanges() {
    this.month = addMonths(new Date(), -1).toLocaleString('nb-NO', {
      month: 'long'
    });

    if (this.analyzedConsumption.result === 'DANGER_OF_INCREASE') {
      this.information =
        'Du var i fare for å gå opp et trinn, men du klarte å holde deg under grensen. Bra jobba! 🥳';
    } else if (
      this.analyzedConsumption.result === 'REDUCTION_POSSIBLE_NEXT_MONTH'
    ) {
      this.information =
        'Basert på ditt forbruk tror vi du kan klare å gå ned et trinn neste måned med små grep. Da kan du spare ' +
        (this.analyzedConsumption.current_step.cost -
          this.analyzedConsumption.previous_step.cost) +
        'kr på neste strømregning 🤩';
    } else if (
      this.analyzedConsumption.result === 'KEEP_CALM_AND_CARRY_ON_AS_USUAL' ||
      this.analyzedConsumption.result === 'WHOHOO_YOU_ARE_DOING_GREAT'
    ) {
      this.information = 'Du gjør det kjempebra! Fortsett som du gjør 😄';
    }
  }
}
